<template>
  <Plan
    title="Free"
    description="Our free-forever plan has all of the basics to help your
                    audience grow."
    price="0"
    :features="FEATURES"
    :disabled="disabled"
  >
    <template v-if="!$slots.actions" #actions>
      <slot name="actions" />
    </template>
    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />
  </Plan>
</template>

<script>
import Plan from './plan';

const FEATURES = [
  {
    title: 'Blazing fast bio link built for conversions',
  },
  {
    title: 'Unlimited links',
  },
  {
    title: 'Advanced customization features to reflect your brand',
  },
  {
    title: 'Powerful and versatile link types to keep your content fresh',
    checked: false,
  },
  {
    title: 'In-depth analytics to track views, clicks, referral, geo and more',
    checked: false,
  },
  {
    title:
      'Unlock premium integrations like Opt-in forms, Forms, Tracking Pixels, and more',
    checked: false,
  },
];

export default {
  components: {
    Plan,
  },

  props: {
    disabled: Boolean,
  },

  setup() {
    return {
      FEATURES,
    };
  },
};
</script>

<style lang="scss" scoped></style>
